export default __webpack_public_path__ + "static/media/03.210be0ce.png";